import { CreateCustomInvoiceParams } from "../TriplePInterface";

export interface CustomInvoicePayload {
  invoice_items: {
    description: string;
    quantity: number;
    base_price: number;
  }[];
}

export const toCustomInvoicePayload = (
  form: CreateCustomInvoiceParams
): CustomInvoicePayload => {
  const invoiceItems = form.form.invoiceItems.map((i) => {
    return {
      description: i.description,
      quantity: +i.quantity,
      base_price: +i.basePrice,
    };
  });

  return {
    invoice_items: invoiceItems,
  };
};
